import { Box, CardContent, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../../../helpers/utilityFunctions/utilityFunctions';
import { ParameterCard } from '../../../documented/ParameterCard';
import { ReactComponent as Background } from './averageSwingSpeedBackground.svg';
import { AverageSwingSpeedCardData } from './averageSwingSpeedCardData';

interface AverageSwingSpeedCardProps {
  data?: AverageSwingSpeedCardData;
  onClick: (arg: string) => void;
}

const CardDetailTypography = styled(Typography)(() => ({
  fontSize: 14,
  padding: '0px 0px 0px 16px !important',
}));

const AverageSwingSpeedCardMedia = styled(CardContent)(() => ({
  display: 'flex !important',
  flexDirection: 'column',
  flexGrow: '1 !important',
}));

const AverageSwingSpeedCard: React.FC<AverageSwingSpeedCardProps> = ({
  data,
  onClick,
}: AverageSwingSpeedCardProps) => {
  const { t } = useTranslation('cards');
  return (
    <ParameterCard
      title={t('averageSwingSpeed.title')}
      iconName="AverageSwingSpeed"
      onClick={() => onClick('_10MWT')}
      enabled={!isEmpty(data)}
    >
      <CardDetailTypography>
        {t('averageSwingSpeed.description')}
      </CardDetailTypography>
      <AverageSwingSpeedCardMedia>
        <Box
          sx={{
            position: 'relative', // Establishes stacking context for layering
            height: 206.148,
            width: 173,
          }}
        >
          <Background
            style={{
              position: 'absolute', // Positions the SVG at the bottom
              top: 0,
              left: 0,
              height: '100%',
              width: '100%',
              zIndex: 1, // Ensures it's behind the content
            }}
          />

          <Grid
            sx={{
              position: 'absolute', // Ensures typography sits on top of the background
              height: '100%',
              width: '100%',
              direction: 'column',
              alignItems: 'center',
              justifyContent: 'space-between',
              zIndex: 2, // Places it above the background
            }}
            container
          >
            <Grid

              sx={{
                width: '86.5px',
                display: 'flex',
                flexDirection: 'column',
                margin: '0px 0px 0px -20px',
              }}
            >
              <Typography
                sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center' }}
              >
                {data ? Number(data.left.value) : 0}
              </Typography>
              <Typography
                sx={{
                  fontWeight: 'bold',
                  fontSize: 20,
                  textAlign: 'center',
                }}
              >
                {data ? data.unit : 'N/A'}
              </Typography>
            </Grid>

            <Grid

              sx={{
                width: '86.5px',
                display: 'flex',
                flexDirection: 'column',
                margin: '0px -20px 0px 0px',
              }}
            >
              <Typography
                sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center' }}
              >
                {data ? Number(data.right.value) : 0}
              </Typography>
              <Typography
                sx={{
                  fontWeight: 'bold',
                  fontSize: 20,
                  textAlign: 'center',
                }}
              >
                {data ? data.unit : 'N/A'}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </AverageSwingSpeedCardMedia>
    </ParameterCard>
  );
};

export default AverageSwingSpeedCard;
